"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitStaal = exports.cbTransportMethod = exports.cbBy = exports.tbDestinationInfo = exports.tbSupplyRemark = exports.tbPackaging = exports.tbTransportMethod = exports.tbSealNumber2 = exports.tbSealNumber1 = exports.tbLocation = exports.tbBy = void 0;
var Algemeen = require("./Algemeen");
var ComboboxNew = require("./ComboboxNew");
var Aanvraag = require("./Aanvraag");
var ApplicationDate = require("./AanvraagStaal/ApplicationDate");
function InitStaal() {
    ApplicationDate.InitApplicationDate();
    exports.tbBy = $('#ctl00_cphBody_tbBy');
    exports.cbBy = new ComboboxNew.ComboBoxNew(exports.tbBy, 'divDropDownItem', 'divDropDownItemInFocus', 'GetCustomerSamplers', true, true, undefined);
    exports.cbBy.Init();
    exports.cbBy.RunAfterWebServiceOnSuccess = function () {
        if (Aanvraag.EditMode) {
            var gevonden = false;
            for (var i = 0; i < exports.cbBy.dataAll.length; i++) {
                if ((exports.cbBy.dataAll[i].Description == Aanvraag.AanvraagObj.By) || (exports.cbBy.dataAll[i].Code == Aanvraag.AanvraagObj.By)) {
                    exports.cbBy.$tb.val(exports.cbBy.dataAll[i].Description);
                    exports.cbBy.selectedValue = exports.cbBy.dataAll[i].Code;
                    gevonden = true;
                    break;
                }
            }
            if (!gevonden) {
                exports.cbBy.$tb.val(Aanvraag.AanvraagObj.By);
            }
        }
    };
    exports.tbLocation = $('#ctl00_cphBody_tbLocation');
    Algemeen.DisableEnterKey(exports.tbLocation);
    exports.tbSealNumber1 = $('#ctl00_cphBody_tbSealNumber1');
    Algemeen.DisableEnterKey(exports.tbSealNumber1);
    exports.tbSealNumber2 = $('#ctl00_cphBody_tbSealNumber2');
    Algemeen.DisableEnterKey(exports.tbSealNumber2);
    exports.tbTransportMethod = $('#ctl00_cphBody_tbTransportMethod');
    exports.cbTransportMethod = new ComboboxNew.ComboBoxNew(exports.tbTransportMethod, 'divDropDownItem', 'divDropDownItemInFocus', 'GetTransportMethods', false, true, ((Aanvraag.EditMode) ? Aanvraag.AanvraagObj.TransportMethod : undefined));
    exports.cbTransportMethod.Init();
    exports.tbPackaging = $('#ctl00_cphBody_tbPackaging');
    Algemeen.DisableEnterKey(exports.tbPackaging);
    exports.tbSupplyRemark = $('#ctl00_cphBody_tbSupplyRemark');
    Algemeen.DisableEnterKey(exports.tbSupplyRemark);
    exports.tbDestinationInfo = $('#ctl00_cphBody_tbDestinationInfo');
    Algemeen.DisableEnterKey(exports.tbDestinationInfo);
}
exports.InitStaal = InitStaal;
function ValidateStaal() {
    return true;
}
